import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useAlert } from "../../../hooks/useAlert";
import { flightHistorySources, flightHistoryState, flightHistoryTargetState, flightHistoryTooltipControllerState, flightHistoryWindowState } from "../../../store/FlightHistoryState";
import { mapContentsVisibleWithID } from "../../../store/MapContentsState";
import { deepCopy } from "../../../utils/FPEUtils";
import FlightHistoryTooltip from "../../copilot/FlightHistoryTooltip";
import FlightHistoryTooltipController from "../../copilot/FlightHistoryTooltipController";
import ContentsDispatcher from "./ContentsDispatcher";
import { useLinkableSourceList } from "../../../store/AircraftSettingState";
import { coPiTooltipSettings } from "../../../store/CopilotState";


const FlightHistoryDispatcher = (props) => {
  const {contentsID, contents} = props;
  const visible = useRecoilValue(mapContentsVisibleWithID(contentsID));
  const {showWarning} = useAlert();

  const flightHistoryTarget = useRecoilValue(flightHistoryTargetState);
  useEffect(() => {
    if (flightHistoryTarget.type) {
      contents.updateData([]);
    }
  }, [flightHistoryTarget, contents]);

  // Flight Historyデータをコンテンツに設定する
  const flightHistoryData = useRecoilValue(flightHistoryState);
  const [historySources, setFlightHistorySources] = useRecoilState(flightHistorySources);
  const {linkableSourceList} = useLinkableSourceList();
  const setTooltipControllerState = useSetRecoilState(flightHistoryTooltipControllerState);
  const tooltipSettings = useRecoilValue(coPiTooltipSettings);
  useEffect(() => {
    if (flightHistoryData?.features?.length === 0) {
      showWarning('Flight history did not find.', {timeout: 3000});
      return;
    }
    if (flightHistoryData.type === "FeatureCollection") {
      contents.updateData(flightHistoryData.features);
      const sources = Array.from(new Set(flightHistoryData.features.map(f => f.properties.data_source_id))).filter(s => s).map(s => {return {dataSourceId: s, visible: true}});
      const order = linkableSourceList.map(l => l.data_source_id);
      const orderedSource = sources.sort((a, b) => {
        return order.indexOf(a.dataSourceId) - order.indexOf(b.dataSourceId);
      })
      setFlightHistorySources(orderedSource);
      setTooltipControllerState(prev => {
        const newData = deepCopy(prev);
        if (!newData.find(d => d.name === 'Aircraft Code')) {
          newData.push({name: 'Aircraft Code', visible: true, enabled: true});
        }
        if (!newData.find(d => d.name === 'Aircraft Name')) {
          newData.push({name: 'Aircraft Name', visible: true, enabled: true});
        }
        sources.forEach(s => {
          const dataSourceId = s.dataSourceId;
          const setting = tooltipSettings[dataSourceId];
          if (setting) {
            const history = setting['History-tooltip'];
            history.forEach(h => {
              const label = h.label;
              const control = newData.find(d => d.name === label);
              if (!control) {
                newData.push({name: label, visible: true, sources: [dataSourceId], enabled: true});
              } else {
                control.sources.push(dataSourceId);
              }
            });
          }
        });
        return newData;
      });
    }
    if (flightHistoryData.URL) {
      const a = document.createElement('a');
      a.href = flightHistoryData.URL;
      a.click();
    }
  }, [contents, flightHistoryData, showWarning, setFlightHistorySources, linkableSourceList, setTooltipControllerState, tooltipSettings]);

  useEffect(() => {
    contents.setSources(historySources);
    setTooltipControllerState(prev => {
      const targets = historySources.filter(s => s.visible).map(s => s.dataSourceId);
      const newData = deepCopy(prev);
      newData.forEach(d => {
        if (d.sources) {
          d.enabled = d.sources.some(s => targets.includes(s));
        }
      });
      return newData;
    });
  }, [contents, historySources, setTooltipControllerState]);

  const setFlightHistoryWindow = useSetRecoilState(flightHistoryWindowState);
  contents.setFlightHistoryWindowDispatcher((geo) => {
    setFlightHistoryWindow(prev => {
      const newData = deepCopy(prev);
      const data = newData.find(d => d.properties.obs_time === geo.properties.obs_time && d.properties.data_source_id === geo.properties.data_source_id);
      if (!data) {
        newData.push(geo);
        return newData;
      }
      return prev;
    });
  });
 
  return (
  <>
    <ContentsDispatcher {...props}/>
    {
      visible &&
      <>
        <FlightHistoryTooltip></FlightHistoryTooltip>
        <FlightHistoryTooltipController></FlightHistoryTooltipController>
      </>
    }
  </>
  )
};

export default FlightHistoryDispatcher;